import styled, { css } from "styled-components";
import { upperMenuHeight } from "../../../../common/parameters";
import { MobileMenuOpener } from "../../../components/Nav/NavRight/styles";

export const UpperMenu = styled.div`
    height: ${upperMenuHeight}px;
    background-color: ${p => p.theme.c.boost};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    color: ${p => p.theme.c.snow};
    line-height: 30px;
    display: flex;
    align-items: center;
    z-index: 2;
    box-shadow: 0 0 10px 0 ${p => p.theme.c.blackShadow3};
    ${p => p.theme.withNotch(css`
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
    `)}

    button {
        background-color: transparent;
        outline: none;
        border: none;
    }
`;

export const MenuSide = styled.div`
    flex: 1;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .arrow-back {
        width: 32px;
        height: 32px;
        display: block;
    }

    @media screen and (max-width: 375px) {
        .TimeStarted {
            display: none;
        }
    }
`;

export const MenuRight = styled(MenuSide)`
    left: 2px;
    right: auto;
    justify-content: flex-end;
`;

export const MenuLeft = styled(MenuSide)`
    ${p =>
        p.theme.xs(css`
            flex: none;
        `)}
`;

export const Progress = styled.div`
    display: inline-block;
    font-size: 18px;
    color: ${p => p.theme.c.whiteOnActive};
`;

export const ArrowButton = styled.button`
    padding: 0 10px;
    z-index: 100;
    cursor: pointer;
    height: 50px;
    ${p =>
        p.theme.xs(css`
            padding: 0 6px;
        `)}
    .i-arrowback {
        color: ${p => p.theme.c.whiteOnActive};
        display: inline-block;
        position: relative;
        top: 1px;
        font-size: 36px;
    }

    &.Flip {
        .i-arrowback {
            transform: scale(-1, 1);
        }
    }

    &.Inactive {
        opacity: 0.5;
        cursor: default;
        pointer-events: none;
    }
`;

export const JoinBanner = styled.div`
    top: 4px;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 0;
    font-weight: 300;
    font-size: 18px;
    color: ${p => p.theme.c.whiteOnActive};
    ${p =>
        p.theme.xs(css`
            display: none;
        `)}
`;

export const Button = styled.div`
    padding: 2px 8px;
    cursor: pointer;
    font-weight: 300;
    color: ${p => p.theme.c.snowOnActive};
    line-height: 30px;

    [class^="i-"] {
        font-size: 21px;
        top: 4px;
        position: relative;
        margin-right: 4px;
    }

    &:hover {
        opacity: 0.7;
    }
`;

export const MenuOpener = styled(MobileMenuOpener)`
    padding: 16px 12px;
    margin-left: 8px;
    display: inline-block !important;
`;

export const MenuDropdown = styled.div`
    position: absolute;
    top: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${p => p.theme.c.boost};
    box-shadow: 0 0 5px 0 ${p => p.theme.c.blackShadow3};
    padding: 8px;
`;

export const EggHunt = styled.div`
    position: absolute;
    top: ${upperMenuHeight}px;
    width: 20px;
    height: 20px;
    z-index: 1000;
`;

export const EggButton = styled.div`
    position: absolute;
`;

export const GiveUp = styled.button`
    background-color: transparent;
    cursor: pointer;
    height: 50px;
    outline: 0;
    border: none;
    font-size: 18px;
    padding: 9px 12px;
    margin-right: 4px;
    color: ${p => p.theme.c.whiteOnActive};

    &:disabled {
        color: ${p => p.theme.c.pale};
        cursor: default;
    }
`;
